module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-common', {
    attrs: {
      "type": "normal",
      "detail": _vm.detail
    }
  }, [_c('div', {
    staticClass: "m-header"
  }, [_c('h2', {
    staticClass: "title f-taj"
  }, [_vm._v(_vm._s(_vm.detail.title))]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.detail.newsDatetime))]), _vm._v(" "), (_vm.detail.authors) ? _c('span', {
    staticClass: "authors"
  }, [_vm._v(_vm._s(_vm.detail.authors))]) : _vm._e(), _vm._v(" "), (_vm.detail.copyfrom) ? _c('span', {
    staticClass: "copyfrom"
  }, [_vm._v(_vm._s(_vm.detail.copyfrom))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "m-detail"
  }, [(_vm.showMedias) ? _c('div', {
    staticClass: "m-media"
  }, _vm._l((_vm.detail.medias), function(media, index) {
    return _c('div', {
      key: index,
      staticClass: "media-item"
    }, [(media.type === 'video') ? _c('div', {
      staticClass: "m-video",
      style: ({
        height: _vm.videoH
      })
    }, [_c('video', {
      attrs: {
        "src": media.sourceUrl,
        "poster": media.image,
        "x-webkit-airplay": "true",
        "webkit-playsinline": "true",
        "preload": "auto",
        "controls": ""
      }
    })]) : (media.type === 'audio') ? _c('audio-bar', {
      attrs: {
        "src": media.sourceUrl
      }
    }) : (media.type === 'img') ? _c('div', {
      staticClass: "m-img"
    }, [_c('img', {
      attrs: {
        "src": media.image
      }
    })]) : _vm._e(), _vm._v(" "), (media.title) ? _c('p', {
      staticClass: "title f-taj"
    }, [_vm._v(_vm._s(media.title))]) : _vm._e(), _vm._v(" "), (media.description) ? _c('p', {
      staticClass: "summary f-taj"
    }, [_vm._v(_vm._s(media.description))]) : _vm._e()], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.detail.content) ? _c('div', {
    staticClass: "m-content f-taj",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "open-full-btn",
    on: {
      "click": _vm.openFullHandle
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51f61975!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-paper.vue
// module id = 851
// module chunks = 2